import { handleInviteSubmit } from 'actions/Forms';
import { useActionState, useEffect } from 'react';
import { ComponentFields } from 'types/content';
import FormError from './FormError';
import parse from 'html-react-parser';

const InviteForm = ({ data, onContinue }: ComponentFields) => {
  const [state, formAction, isPending] = useActionState(handleInviteSubmit, {
    data: new FormData(),
    errors: {},
    results: {},
    success: false,
  });

  useEffect(() => {
    if (state.success) {
      /* Save the Data and lets move on.. */
      // eslint-disable-next-line no-console
      console.log({ msg: 'Sending Invitation Data', data: state.results });

      onContinue();
    }
  }, [state.results, state.success, onContinue]);

  const handleSkip = () => {
    onContinue();
  };

  return (
    <section className="layout-container">
      <div>
        <h2>{data.elements.title?.value}</h2>

        <form action={formAction}>
          <div className="stack">
            <label>
              <b>Name</b>
              <br />
              <input
                type="text"
                name="name"
                className="input half"
                defaultValue={state.data.get('name') as string}
              />
              {state.errors.name && <FormError error={state.errors.name} />}
            </label>

            <label>
              <b>Spouse&apos;s email address</b>
              <br />
              <input
                type="email"
                name="email"
                className="input half"
                defaultValue={state.data.get('email') as string}
              />
              {state.errors.email && <FormError error={state.errors.email} />}
            </label>

            <section>
              <button
                className="button primary"
                type="submit"
                disabled={isPending}
              >
                Submit
              </button>

              <button
                className="button secondary"
                type="button"
                onClick={handleSkip}
              >
                Skip this, I changed my mind
              </button>

              {isPending && <div className="spinner"></div>}
            </section>

            <section>{parse(data.elements.disclaimer?.value)}</section>
          </div>
        </form>
      </div>
    </section>
  );
};

export default InviteForm;
